import { QueryResult } from "@apollo/client";
import { logger } from "lib/logger/browser";

import { ApiParams, getListDiscoverTeamsVariables } from "./listDiscoverTeams";

import {
  useListDiscoverTeamsQuery,
  ListDiscoverTeamsQuery,
} from "lib/types/graphql";

type HookResult = QueryResult<ListDiscoverTeamsQuery>;

export default function useListDiscoverTeams(apiParams: ApiParams): HookResult {
  return useListDiscoverTeamsQuery({
    variables: getListDiscoverTeamsVariables(apiParams),
    fetchPolicy: "cache-first",
    onError: logger.error,
  });
}
